var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 2,
    viewBox: "0 0 4 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.824 3.284C1.64 3.284 1.468 3.252 1.308 3.188C1.148 3.116 1.004 3.016 0.876 2.888C0.756 2.76 0.66 2.608 0.588 2.432C0.516 2.256 0.48 2.06 0.48 1.844C0.48 1.628 0.516 1.432 0.588 1.256C0.66 1.072 0.756 0.92 0.876 0.8C1.004 0.672 1.148 0.572 1.308 0.5C1.468 0.428 1.64 0.392 1.824 0.392C2 0.392 2.168 0.428 2.328 0.5C2.496 0.572 2.64 0.672 2.76 0.8C2.888 0.92 2.988 1.072 3.06 1.256C3.132 1.432 3.168 1.628 3.168 1.844C3.168 2.06 3.132 2.256 3.06 2.432C2.988 2.608 2.888 2.76 2.76 2.888C2.64 3.016 2.496 3.116 2.328 3.188C2.168 3.252 2 3.284 1.824 3.284Z",
    fill: "#465169"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDot);
export default __webpack_public_path__ + "static/media/dot.09693420e17ef920fdccf2fc5b8db45a.svg";
export { ForwardRef as ReactComponent };